// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_gv-0";
export var headerCellHover = "_gv-1";
export var readCellContainer = "_gv-2";
export var unreadIndicator = "_gv-3";